import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonnelAdvancedSearchFormComponent } from './form/components/personnel-advanced-search-form.component';
import {NgxAngularQueryBuilderModule} from "ngx-angular-query-builder";
import {SelectButtonModule} from "primeng/selectbutton";
import {TableModule} from "primeng/table";
import {HvlNgSharedModule, PrimengSharedModule} from "@hvlng/framework-core/shared";
import {UiSharedModule} from "ui-shared";
import {DynamicDialogModule} from "primeng/dynamicdialog";
import {ToolbarModule} from "primeng/toolbar";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HvlFormItemModule, HvlFormMessageModule, HvlMlDropdownModule} from "@hvlng/framework-core/form";
import {ToggleButtonModule} from "primeng/togglebutton";
import {MenuModule} from "primeng/menu";
import {AccordionModule} from "primeng/accordion";
import { HumanresourcesCommonSharedModule } from 'humanresources-common-shared';
import {
    HrPerPersonnelSearchModule
} from "../personnel-operations/component/hr-per-personnel-search/hr-per-personnel-search.module";
import {OrganizationSelectionModule} from "../organization/organization-picker/organization-selection.module";
import {PositionPickerModule} from "../organization/position-picker/position-picker.module";
import {TitleSearchModule} from "../organization/title-search/title-search.module";



@NgModule({
  declarations: [
    PersonnelAdvancedSearchFormComponent
  ],
    exports: [
        PersonnelAdvancedSearchFormComponent
    ],
    imports: [
        CommonModule,
        TableModule,
        PrimengSharedModule,
        UiSharedModule,
        HvlNgSharedModule,
        DynamicDialogModule,
        ToolbarModule,
        FormsModule,
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        HvlFormMessageModule,
        HvlFormItemModule,
        HvlMlDropdownModule,
        ToggleButtonModule,
        MenuModule,
        HumanresourcesCommonSharedModule.forRoot(),
        AccordionModule,
        NgxAngularQueryBuilderModule,
        HrPerPersonnelSearchModule,
        OrganizationSelectionModule,
        PositionPickerModule,
        TitleSearchModule
    ]
})
export class PersonnelAdvancedSearchModule { }
